import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p><span
                                                className="subtiltereg">What was the item they needed?</span>
                                            </p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve green_curve1">Answer
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="center"
                                                        className="lightgreen">
                                                            <textarea className="curved_textarea"
                                                                      rows="5"
                                                                      cols="100"
                                                                      name="WhatWasTheItemTheyNeeded"
                                                                      value={this.props.pageData?.WhatWasTheItemTheyNeeded}
                                                                      onChange={this.props.handleChangePageData}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <p>See the preference scenario answer sheet at the end of this
                                                tool for the answer.</p>
                                            <p>Now that you know what the answer is, let’s see how, using
                                                your preferences, you would answer.
                                                This also gives you a chance to see how people who think in
                                                different ways may arrive at their answer:</p>


                                            <table
                                                className="ilead_v_sport tablesrink uiheading ilead_v_sport_center"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" valign="center"
                                                        width="20%">If you have a strong
                                                        preference for...
                                                    </th>
                                                    <th className="green_curve1" align="left"
                                                        valign="center" width="40%">You are likely to...
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg">Bigger picture</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have considered why the strangers were buying the
                                                            apartments
                                                            and where their home towns might be. You would
                                                            have
                                                            considered the overall picture and its most
                                                            significant elements.
                                                            For example, which building materials would be
                                                            most
                                                            economical and which could be bought most
                                                            cheaply in bulk?</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg"> Detail focused</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p> have thought about the minutiae – precisely what
                                                            was the
                                                            missing item needed for constructing apartment
                                                            blocks? You
                                                            probably focused on important information, like
                                                            numbers, costs
                                                            and the sort of problems encountered in
                                                            construction as well
                                                            the significance of needing to visit a hardware
                                                            store.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">  Creative</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have thought about the kind of materials used to
                                                            construct
                                                            apartment buildings, using your own experience
                                                            or knowledge.
                                                            You may have considered what style of apartment
                                                            blocks they
                                                            were building to work out what the missing items
                                                            might be.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">  Literal</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p> have looked at the available information and
                                                            worked through
                                                            it systematically, to see if any of it indicates
                                                            what the missing
                                                            items were. You probably focused on the price of
                                                            the individual
                                                            item, the different quantities and scale of
                                                            costs to solve
                                                            the problem.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">  Logical</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have tried to establish if there were clues or
                                                            logical links in the
                                                            text alone. You would probably think about the
                                                            likely cost of
                                                            items used for this particular purpose.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">  Intuitive</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have relied on your initial ‘gut feeling’ or
                                                            instinct about a
                                                            particular aspect, such as whether the pricing
                                                            was correct
                                                            or whether the unit cost needed to be low
                                                            because of the
                                                            number of items needed, etc.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page7')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}